<template>
  <div class="logs-wrapper" :class="{ 'has-header': hasHeader }">
    <div class="no-ticket" v-if="!logTickets || logTickets.length <= 0">
      {{ $t('No tickets earned') }}
    </div>
    <div class="ticket-log" v-for="ticket in logTicketsWithDateInfo" :key="ticket.label || ticket.id">
      <div v-if="ticket.type === 'date-label'" class="date-label">{{ ticket.label }}</div>
      <div v-else class="details">
        <div class="image-wrapper">
          <img
            v-if="ticket.jackpot.type === 0"
            :src="require(`@/assets/images/${getTicketType(ticket.jackpotTicket.color)}-ticket.webp`)"
          />
          <img v-if="ticket.jackpot.type === 1" :src="require(`@/assets/images/instant-prize.webp`)" />
        </div>
        <div class="log-text">{{ ticketLogText(ticket) }}</div>
        <div class="created-date">
          {{ getTicketDate(ticket.createdDateTime) }}
        </div>
      </div>
    </div>
    <button v-if="hasMoreTicket" class="load-more" @click="loadMoreTickets">{{ loadMoreText }}</button>
  </div>
</template>
<script>
import { formatAmountWithKM } from '@/utils/helpers';
import { mapGetters } from 'vuex';

export default {
  props: {
    logTickets: {
      type: Array,
      default: [],
    },
    ticketsLength: {
      type: Number,
      default: 0,
    },
    hasHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('general', ['member', 'timezone']),
    ...mapGetters('jackpot', ['ticketPagination', 'ticketLoading']),
    currencySymbol() {
      return this.member.currencySymbol;
    },
    loadMoreText() {
      return this.ticketLoading ? this.$t('loading') : this.$t('Load more');
    },
    hasMoreTicket() {
      if (this.ticketsLength <= 0) return false;
      const curTicketCount = this.ticketsLength;
      const { page: curPage, pageSize: curPageSize } = this.ticketPagination;
      return curTicketCount >= curPageSize * (curPage - 1);
    },
    logTicketsWithDateInfo() {
      let dateInfo = '';
      const currentDate = this.$moment().tz(this.timezone).format('DD/MM/YYYY');
      const result = [];
      this.logTickets.forEach((t) => {
        const ticketDate = this.$moment(t.createdDateTime).tz(this.timezone).format('DD/MM/YYYY');
        if (ticketDate !== dateInfo) {
          dateInfo = ticketDate;
          result.push({
            type: 'date-label',
            label: ticketDate === currentDate ? 'Today' : dateInfo,
          });
        }
        result.push(t);
      });
      return result;
    },
  },
  methods: {
    loadMoreTickets() {
      this.$emit('loadMoreTickets');
    },
    getTicketType(color) {
      switch (color) {
        case 'red':
          return 'major';
        case 'green':
          return 'minor';
        case 'blue':
          return 'mini';
      }
    },
    ticketLogText(ticket) {
      console.log({ ticket });
      const ticketId = ticket.sid;
      if (ticket.jackpot.type === 0) {
        if (ticket.luckyDrawWinner && ticket.luckyDrawWinner.amount) {
          return `${this.$t('Lucky draw')}: ${this.currencySymbol} ${ticket.luckyDrawWinner.amount}`;
        }
        return this.$t('You earn lucky draw ticket #{ticketId}', {
          ticketId,
        });
      } else {
        const amount = formatAmountWithKM(Number(ticket.rebate), 2);
        return `${this.$t('Instant prize')}: ${this.currencySymbol} ${amount}`;
      }
    },
    getTicketDate(timeString) {
      return this.$moment(timeString).tz(this.timezone).format('MM-DD | HH:mm:ss');
    },
  },
};
</script>
<style scoped lang="scss">
.logs-wrapper {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  &.has-header {
    height: calc(100% - 56px);
    padding: 12px;
  }
  .no-ticket {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: #759fb5;
  }
  .ticket-log {
    display: flex;
    padding: 8px 0;
    font-size: 11px;
    border-bottom: 1px dashed #142f4b;
    align-items: center;
    width: 100%;

    .date-label {
      font-size: 14px;
      text-align: left;
      color: #fff;
    }
    .details {
      color: #b2d6ea;
      display: flex;
      flex: 1;
      align-items: center;
      width: 100%;

      .image-wrapper {
        height: 16px;
        width: 24px;
        text-align: center;
        margin-right: 8px;
        img {
          height: 16px;
        }
      }
      .log-text {
        display: flex;
        flex: 4;
      }
      .created-date {
        color: #759fb5;
      }
    }
  }
}

button.load-more {
  @include load-more;
}
</style>
